<script setup lang="ts">
import RadioInput from "~/components/Common/Inputs/RadioInput.vue";
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["cancel", "confirm"]);
const props = defineProps({
  disable: {
    type: Boolean,
    default: false,
  },
});
const keepSubscriptions = ref();

function cancel() {
  emit("cancel");
}

async function confirm() {
  emit("confirm", keepSubscriptions.value);
}

onMounted(() => {
  keepSubscriptions.value = true;
});
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }">
    <template #body>
      <div class="grid p-[24px] gap-[24px] body_regular">
        <div class="flex flex-col gap-2">
          <h4 class="heading_4_demi">Voulez-vous supprimer le(s) participant(s) ?</h4>
          <p class="text-secondary-color">Cette action ne sera pas modifiable.</p>
        </div>
        <div class="flex flex-col gap-2">
          <span class="body_regular">Supprimer leurs inscriptions aux formations du parcours ?</span>
          <div class="flex flex-col gap-4">
            <label class="flex gap-2 w-fit" :class="props.disable ? 'cursor-not-allowed' : 'cursor-pointer'">
              <RadioInput
                v-model="keepSubscriptions"
                class="min-w-[16px] min-h-[16px]"
                :checked="keepSubscriptions"
                :value="true"
                :disabled="props.disable"
                @click="keepSubscriptions = true"
              />
              <span class="body_regular" :class="{ 'text-secondary-color': props.disable }"
                >Conserver les inscriptions</span
              >
            </label>
            <label class="flex gap-2 w-fit" :class="props.disable ? 'cursor-not-allowed' : 'cursor-pointer'">
              <RadioInput
                v-model="keepSubscriptions"
                class="min-w-[16px] min-h-[16px]"
                :checked="!keepSubscriptions"
                :value="false"
                :disabled="props.disable"
                @click="keepSubscriptions = false"
              />
              <span class="body_regular" :class="{ 'text-secondary-color': props.disable }"
                >Supprimer toutes les inscriptions</span
              >
            </label>
          </div>
        </div>
        <div class="flex justify-center gap-[16px]">
          <AppButton type="outlined" label="Annuler" class="w-full" @click="cancel" />
          <AppButton label="Supprimer" class="w-full" variant="error" @click="confirm" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
